import { useEffect } from "react";
import {
  RouterProvider,
  type RouterProviderProps,
} from "react-router-dom";
import { useDocumentBranding } from "./hooks/useDocumentBranding";
import { initializeAuth, refreshPermissions } from "./redux/authSlice";
import { useAppDispatch, useAppSelector } from "./redux/hooks";
import API from "./services/api";

function App({ router }: { router: RouterProviderProps["router"] }) {
  const dispatch = useAppDispatch();
  const language = useAppSelector((state) => state.company.language);
  const initialized = useAppSelector((state) => state.auth.initialized);
  const isAuthenticated = useAppSelector(
    (state) => state.auth.isAuthenticated || state.company.isAuthenticated,
  );

  useDocumentBranding();

  useEffect(() => {
    void dispatch(initializeAuth());
  }, [dispatch]);

  useEffect(() => {
    if (initialized && isAuthenticated) {
      void dispatch(refreshPermissions());
      const storedExpiresIn = localStorage.getItem("tokenExpiresIn");
      const expiresIn = storedExpiresIn
        ? Number.parseInt(storedExpiresIn, 10)
        : 300;
      API.scheduleProactiveRefresh(expiresIn);
    }
  }, [dispatch, initialized, isAuthenticated]);

  useEffect(() => {
    document.documentElement.lang = language;
    document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
  }, [language]);

  if (!initialized) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <span>Initializing...</span>
      </div>
    );
  }

  return <RouterProvider router={router} />;
}

export default App;
